/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISecureUploadCompleteMutationVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  uploadId: Types.Scalars['String']['input'];
  filename: Types.Scalars['String']['input'];
  parts: Array<Types.ISecureUploadPartParams> | Types.ISecureUploadPartParams;
  size: Types.Scalars['BigInt']['input'];
  contentType: Types.AssetContentTypeEnum;
}>;

export type ISecureUploadCompleteMutation = {
  __typename?: 'Mutation';
  secureUploadComplete?: {
    __typename?: 'SecureUploadCompletePayload';
    success: boolean;
    errors?: Array<string> | null;
    asset?: { __typename?: 'Asset'; id: string; depositStatus: Types.DepositStatusEnum } | null;
  } | null;
};

export const SecureUploadCompleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'secureUploadComplete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parts' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'SecureUploadPartParams' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetContentTypeEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secureUploadComplete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uploadId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filename' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'parts' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'parts' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISecureUploadCompleteMutation, ISecureUploadCompleteMutationVariables>;
